import React, { useState } from "react";
import "./Filters.css";

interface FilterProps {
  filters: { [key: string]: string[] }; // Categories with sub-categories
  onFilterChange: (filter: string, isChecked: boolean) => void; // Callback for filter changes
}

const Filters = ({ filters, onFilterChange }: FilterProps) => {
  // State to track the checked status of main categories
  const [mainCategoryChecked, setMainCategoryChecked] = useState<{
    [key: string]: boolean;
  }>({});

  // State to track the checked status of individual sub-categories
  const [subCategoryChecked, setSubCategoryChecked] = useState<{
    [key: string]: { [subCategory: string]: boolean };
  }>({});

  // Handle checking/unchecking of the main category (select all sub-categories)
  const handleMainCategoryChange = (category: string, isChecked: boolean) => {
    // Set the main category checked status
    setMainCategoryChecked((prev) => ({
      ...prev,
      [category]: isChecked,
    }));

    // Set the individual sub-category checked status based on the main category checkbox
    if (filters[category]) {
      filters[category].forEach((subCategory) => {
        onFilterChange(subCategory, isChecked); // Also trigger the main category change for sub-categories
        setSubCategoryChecked((prev) => ({
          ...prev,
          [category]: {
            ...prev[category],
            [subCategory]: isChecked, // Sync sub-category checked status
          },
        }));
      });
    }
    onFilterChange(category, isChecked); // Also trigger the main category change
  };

  // Handle checking/unchecking of individual sub-categories
  const handleSubCategoryChange = (
    category: string,
    subCategory: string,
    isChecked: boolean
  ) => {
    setSubCategoryChecked((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [subCategory]: isChecked, // Update the checked status for this specific sub-category
      },
    }));
    onFilterChange(subCategory, isChecked); // Trigger filter change for individual sub-category
  };

  return (
    <div className="product-store-filter-container">
      <div style={{ color: "gray", marginBottom: "10px" }}>Filter by:</div>
      <div style={{ fontWeight: "bold" }}>Design Category</div>
      <div className="product-store-filter-list">
        {Object.entries(filters).map(([category, subCategories]) => (
          <div
            key={category}
            className="product-store-filter-category-container"
          >
            {/* Main category checkbox */}
            <div
              className={`product-store-filter-category-title ${
                subCategories.length > 0 ? "has-subcategories" : ""
              }`}
            >
              <input
                type="checkbox"
                id={category}
                name={category}
                checked={mainCategoryChecked[category] || false}
                onChange={(e) =>
                  handleMainCategoryChange(category, e.target.checked)
                }
              />
              <label
                htmlFor={category}
                className="product-store-filter-category-label"
              >
                {category}
              </label>
            </div>

            {/* Render sub-categories (they are automatically expanded) */}
            {subCategories.length > 0 && (
              <div className="product-store-filter-subcategories-container">
                {subCategories.map((subCategory) => (
                  <div
                    key={subCategory}
                    className="product-store-filter-subcategory"
                  >
                    <input
                      type="checkbox"
                      id={subCategory}
                      name={subCategory}
                      checked={
                        subCategoryChecked[category]?.[subCategory] || false
                      }
                      onChange={(e) =>
                        handleSubCategoryChange(
                          category,
                          subCategory,
                          e.target.checked
                        )
                      }
                    />
                    <label htmlFor={subCategory}>{subCategory}</label>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Filters;
